const mq = window.matchMedia('(min-width: 768px)')

export default mq
